import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { StorageService } from "src/app/core/services/storage.service";
import { environment } from "src/environments/environment";

@Component({
  selector: 'BTA-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent {

  public logoUrl = environment?.logoUrl;
  public imageUrl = environment?.imageUrl;
  public clientAbbr = environment?.clientAbbr;
  public logoHeight = environment?.logoHeight;
  public isWhitelabel = this.storageService.getLocalStorageItem('whitelabel')
  public logoFailed = false;

  // imageUrl + logoUrl is the CDN copy; when it 404s (or the CDN is down) fall
  // back to logoUrl on its own. Guarded so a failing fallback can't re-enter.
  onLogoError() {
    if (!this.logoFailed) this.logoFailed = true;
  }

  constructor(
    private storageService: StorageService
  ) { }

}